import React from "react";

import {
    IS_VALID
} from "utils";

let schema = {
    className: "MobileAppConfig",
    limit: 10,
    showExport: false,
    showView: true,
    showCreate: false,
    showUpdate: false,
    showDelete: false,
    columns: [
        {
            columnName: "objectId",
            type: "string"
        },
        {
            columnName: "name",
            type: "string",
            render: ({ object }) => {
                let name = IS_VALID(object.get("name")) ? object.get("name") : "";
                
                return name;
            }
        },
        {
            columnName: "message",
            type: "string",
            render: ({ object }) => {
                let message = IS_VALID(object.get("message")) ? object.get("message") : "";
                
                return message;
            }
        },
        {
            columnName: "key",
            type: "string",
            render: ({ object }) => {
                let key = IS_VALID(object.get("key")) ? object.get("key") : "";
                
                return key;
            }
        },
        {
            columnName: "isActive",
            columnLabel: "status",
            type: "boolean",
            style: {
                textAlign: "center"
            },
            render: ({ object }) => {
                let isActive = IS_VALID(object.get("isActive")) ? object.get("isActive") : false;
                
                return <span style={{ color: isActive ? "green" : "red" }}>{isActive ? "ACTIVE" : "INACTIVE"}</span>    
            }
        },
        {
            columnName: "createdAt",
            type: "Date"
        },
        {
            columnName: "updatedAt",
            type: "Date"
        }
    ]
};

module.exports = schema;


// WEBPACK FOOTER //
// ./components/MobileAppConfig/MobileAppConfigSchema.js